import React from "react";
import "../css/Trainers.css";

const Trainers = () => {
  return (
    <div className="trainers2">

      {/* HERO */}
      <section className="t2-hero">
        <div className="t2-hero-inner">
          <h1>THE ARCHITECTS OF FORM</h1>
          <p>Meet the elite minds shaping the FLEXOR training philosophy.</p>
        </div>
      </section>


      {/* TRAINER GRID */}
      <section className="t2-grid">
        
        {[
          {
            name: "ALEX MERCER",
            role: "Strength & Conditioning",
            img: "https://images.pexels.com/photos/5327524/pexels-photo-5327524.jpeg"
          },
          {
            name: "ELLA TORRES",
            role: "Mobility & Flexibility",
            img: "https://images.pexels.com/photos/3822668/pexels-photo-3822668.jpeg"
          },
          {
            name: "JASON KAI",
            role: "HIIT // Metabolic Training",
            img: "https://images.pexels.com/photos/4058411/pexels-photo-4058411.jpeg"
          },
          {
            name: "NOVA REYES",
            role: "Mind–Body Performance",
            img: "https://images.pexels.com/photos/414029/pexels-photo-414029.jpeg"
          }
        ].map((t, i) => (
          <div className="t2-card" key={i}>
            <div
              className="t2-img"
              style={{ backgroundImage: `url(${t.img})` }}
            ></div>
            <div className="t2-info">
              <h2>{t.name}</h2>
              <p>{t.role}</p>
            </div>
          </div>
        ))}

      </section>


      {/* CINEMATIC TRAINER STRIP */}
      <section className="t2-wide">
        <div className="t2-wide-img"></div>
        <div className="t2-wide-text">
          <h1>CRAFTED THROUGH EXPERIENCE</h1>
          <p>
            FLEXOR trainers come from competitive sport, biomechanics, 
            martial arts, and high-performance coaching — united by a single 
            mission: refine your form, sharpen your focus, and expand your potential.
          </p>
        </div>
      </section>


      {/* SPECIALTIES SECTION */}
      <section className="t2-specialties">
        <h1>TRAINING SPECIALTIES</h1>

        <div className="t2-spec-grid">
          {[
            "Strength Development",
            "Mobility Restoration",
            "Endurance Conditioning",
            "Explosive Power Output",
            "Functional Movement Patterns",
            "Mind–Muscle Control"
          ].map((s, i) => (
            <div className="t2-spec-card" key={i}>
              {s}
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default Trainers;
